<template>

    <div>
        <div class="row">
            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'home'}">{{$t("inicio")}}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'configuracion'}">{{$t("configuracion")}}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">{{$t("subproductos")}}</li>
                    </ol>
                </nav>
            </div>

            <div class="col-md-12">
                <div class="card">
                    <div class="row">
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="listBusiness">{{$t("negocio")}}</label>

                                <el-select class="select-default"
                                           size="large"
                                           v-model="idBusiness"
                                           filterable
                                           :placeholder="$t('seleccionaNegocio')">
                                    <el-option v-for="business in listBusinesses"
                                               class="select-primary"
                                               :value="business.id"
                                               :label="business.establishmentName"
                                               :key="business.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>


                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="listBusiness">{{$t('usuario')}}</label>

                                <el-select class="select-default"
                                           size="large"
                                           v-model="idUser"
                                           filterable
                                           :placeholder="$t('seleccionaUsuario')">
                                    <el-option v-for="user in listUsers"
                                               class="select-primary"
                                               :value="user.id"
                                               :label="user.firstName +' ' +user.surName"
                                               :key="user.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-12">
                <div class="card">
                    <div class="row">

                        <div class="col-md-12">
                            <el-checkbox v-model="permiso1" @change="editRestriccion(1)" :label="$t('materiaPrima')"
                                         border></el-checkbox>
                            <el-checkbox v-model="permiso2" @change="editRestriccion(2)" :label="$t('proveedores')"
                                         border></el-checkbox>
                            <el-checkbox v-model="permiso3" @change="editRestriccion(3)" :label="$t('etiquetas')"
                                         border></el-checkbox>
                            <el-checkbox v-model="permiso4" @change="editRestriccion(4)" :label="$t('productos')"
                                         border></el-checkbox>
                            <el-checkbox v-model="permiso5" @change="editRestriccion(5)" :label="$t('categorias')"
                                         border></el-checkbox>
                            <el-checkbox v-model="permiso6" @change="editRestriccion(6)" :label="$t('modificadores')"
                                         border></el-checkbox>
                            <el-checkbox v-model="permiso7" @change="editRestriccion(7)" :label="$t('clientes')"
                                         border></el-checkbox>
                            <el-checkbox v-model="permiso8" @change="editRestriccion(8)" :label="$t('casas')"
                                         border></el-checkbox>
                            <el-checkbox v-model="permiso9" @change="editRestriccion(9)" :label="$t('operarios')"
                                         border></el-checkbox>
                            <el-checkbox v-model="permiso10" @change="editRestriccion(10)" :label="$t('agencias')"
                                         border></el-checkbox>
                            <el-checkbox v-model="permiso11" @change="editRestriccion(11)" :label="$t('formasDePago')"
                                         border></el-checkbox>

                        </div>


                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

    import {
        DatePicker,
        Select,
        Option,
        Dropdown,
        DropdownItem,
        DropdownMenu,
        Button,
        Checkbox,
        CheckboxGroup
    } from 'element-ui'
    import {Loading} from 'element-ui';
    import swal from 'sweetalert2'

    export default {

        created() {
//            this.loading = Loading.service({text: 'Cargando...'});
            this.$store.dispatch("setNameRoute", this.$i18n.t("subproductos"));
            this.getBusiness();

            if (this.$store.getters.idBusiness) {
                this.idBusiness = this.$store.getters.idBusiness;
            }

        },
        components: {
            [DatePicker.name]: DatePicker,
            [Select.name]: Select,
            [Dropdown.name]: Dropdown,
            [DropdownItem.name]: DropdownItem,
            [DropdownMenu.name]: DropdownMenu,
            [Button.name]: Button,
            [Option.name]: Option,
            [CheckboxGroup.name]: CheckboxGroup,
            [Checkbox.name]: Checkbox
        },
        data() {
            return {
                listBusinesses: [],
                idBusiness: this.$route.params.idBusiness,

                listUsers: [],
                idUser: 0,

                /*PRUEBAS PERMISOS*/

                permiso1: false,
                permiso2: false,
                permiso3: false,
                permiso4: false,
                permiso5: false,
                permiso6: false,
                permiso7: false,
                permiso8: false,
                permiso9: false,
                permiso10: false,
                permiso11: false,
            }
        },
        watch: {},
        computed: {},
        methods: {

            getBusiness() {
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
                    .then(function (response) {
                        if (!vm.idBusiness) {
                            vm.idBusiness = response.data.result[0].id;
                        }

                        vm.listBusinesses = response.data.result;

                        vm.getUsers();

                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            getUsers() {
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt,
                        idBusiness: this.idBusiness
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getUsersByBusiness", config)
                    .then(function (response) {


                        vm.listUsers = response.data.result;
                        vm.idUser = response.data.result[0].id


                        vm.getRestrictions();

                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            getRestrictions() {

                var config = {
                    params: {
                        jwt: this.$store.getters.jwt,
                        idUser: this.idUser
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getRestrictionsByUser", config)
                    .then(function (response) {

                        if (response.data.response) {


                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },

            editRestriccion(idRestriccion) {


                var config = {
                    params:{
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };
                var params = {
                    idBusiness: this.idBusiness,
                    idUser: this.idUser,
                    idRestriccion:idRestriccion,
                    jwt: this.$store.getters.jwt
                };

                let vm = this;
                let controller = "editRestrictionsById";
                this.axios.post(this.$store.getters.apiUrl + 'general/' + controller, params, config)
                    .then(function (response) {

                        /*if (response.data.response) {
                            let notify = vm.idSubproducto ? "actualizada" : "creada";
                            vm.$notify({
                                message: 'Subproducto ' + notify + ' correctamente',
                                icon: 'nc-icon nc-check-2',
                                timeout: 2000,
                                horizontalAlign: 'right',
                                verticalAlign: 'top',
                                type: 'success'
                            });


                        } else {
                            swal({
                                title: `Atención`,
                                text: response.data.result,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }*/
                    }).catch(function (error) {
                    console.log(error);
                    vm.inProgress = false;
                });

            }
        }
    }
</script>

<style scoped>


    tbody tr:hover {
        background-color: rgba(0, 153, 130, 0.2);
        cursor: pointer;
    }

    tbody td {
        padding: 0 !important;
    }

    td div {
        padding: 12px 8px;
        color: #333;
    }

    .buttonsSearch:hover {
        cursor: pointer;
        background-color: rgba(0, 153, 130, 0.1);
    }

    .card {
        padding: 20px;
    }

    .input-group button {
        height: 40px;
    }


</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Permisos/Permisos.vue